import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { FX_TRANSACTIONS_PREFIX, TRANSACTIONS_PREFIX } from 'constants';
import Cookies from 'helpers/cookies';
import { useNavigate } from 'react-router-dom';
import { MAKE_PAYMENT_KEY } from './form-add-transaction/useAddTransaction';
import useFormAddTransactionStore from './form-add-transaction/useFormAddTransactionStore';
import { FX_MAKE_PAYMENT_KEY } from './fx/useFxAddTransaction';
import useFxFormAddTransactionStore from './fx/useFxFormAddTransactionStore';
import useCommonStore from './useCommonStore';
import useLang from './useLang';
import usePage from './usePage';
import usePortalModal from './usePortalModal';

const useTxnSubmitError = () => {
  const { t } = useLang();
  const { setLoading } = useCommonStore();
  const navigate = useNavigate();
  const { showPortalModalName } = usePortalModal();
  const { isAddTransactionPage } = usePage();

  const {
    resetAddTransactionInformation: resetAddTransactionInformationTO,
    resetCurrentReceiver,
    resetAddTransactionCurrentStep,
  } = useFormAddTransactionStore();
  const {
    resetAddTransactionInformation: resetAddTransactionInformationFX,
    setAddTransactionCurrentStep,
    setTransactionDetails,
    resetDenomination,
    resetNotes,
  } = useFxFormAddTransactionStore();

  const onTOCleanup = () => {
    resetAddTransactionInformationTO();
    resetCurrentReceiver();
    resetAddTransactionCurrentStep();
    Cookies.remove(MAKE_PAYMENT_KEY);
  };
  const onFXCleanup = () => {
    resetAddTransactionInformationFX();
    setAddTransactionCurrentStep(0);
    setTransactionDetails();
    resetDenomination();
    resetNotes();
    Cookies.remove(FX_MAKE_PAYMENT_KEY);
  };
  const onCleanup = () => {
    if (isAddTransactionPage) {
      onTOCleanup();
      return;
    }
    onFXCleanup();
  };

  const onNavigate = () => {
    if (isAddTransactionPage) {
      navigate(TRANSACTIONS_PREFIX);
      return;
    }
    navigate(FX_TRANSACTIONS_PREFIX);
  };

  const showTxnSubmitErrorModal = () => {
    const timer = setTimeout(() => {
      setLoading(true);
      showPortalModalName({
        name: PORTAL_NAME_MODAL_DEFINE.TXN_SUBMIT_ERROR_POPUP,
        title: '',
        content: t('popup_txn_submit_error_desc'),
        modalOptions: {
          buttonLabel2: t('button_close'),
        },
        modalStyles: {
          subTextStyles: {
            textAlign: 'center',
          },
        },
        action: () => {
          clearTimeout(timer);
          onCleanup();
          onNavigate();
        },
      });
    }, 10000);
  };

  return { showTxnSubmitErrorModal };
};

export default useTxnSubmitError;
